import { prepareImageForUpload } from "./imageUpload";

type FormValue = string | boolean | number;

function requireFileName(file: File): string {
  if (file.name.trim() === "") {
    throw new Error("Upload file has no name");
  }
  return file.name;
}

export async function createImageUploadFormData(
  image: File,
  fields: Record<string, FormValue>,
): Promise<FormData> {
  const preparedImage = await prepareImageForUpload(image);
  const formData = new FormData();
  formData.append("image", preparedImage, requireFileName(preparedImage));

  for (const [key, value] of Object.entries(fields)) {
    formData.append(key, String(value));
  }

  return formData;
}
